const exploreLinks = [
  { href: "#world", label: "Explore" },
  { href: "#categories", label: "Categories" },
  { href: "#products", label: "Products" },
  { href: "#market", label: "Market" },
  { href: "#visit", label: "Visit" },
];

const categoryLinks = ["Mobile", "Laptop", "Audio", "Power", "Cases", "Accessories"];

export default function Footer() {
  return (
    <footer className="bg-background-100">
      <div className="container-x grid gap-10 py-14 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <a href="#top" className="flex items-center gap-2">
            <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-foreground-950">
              <i className="ri-flashlight-fill text-lg"></i>
            </span>
            <span className="font-heading text-lg font-semibold tracking-tight text-foreground-950">
              FIST <span className="text-primary-600">LIMITED</span>
            </span>
          </a>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-600">
            Mobiles, laptops and everyday technology accessories.
          </p>
        </div>

        <div>
          <p className="font-label text-xs text-secondary-500">Navigation</p>
          <ul className="mt-4 space-y-2.5">
            {exploreLinks.map((l) => (
              <li key={l.href}>
                <a href={l.href} className="text-sm text-foreground-700 transition-colors hover:text-primary-600">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-label text-xs text-secondary-500">Categories</p>
          <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2.5">
            {categoryLinks.map((c) => (
              <li key={c}>
                <a href="#categories" className="text-sm text-foreground-700 transition-colors hover:text-primary-600">
                  {c}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-label text-xs text-secondary-500">Contact</p>
          <ul className="mt-4 space-y-2.5 text-sm text-foreground-700">
            <li>86 Eastdale Road</li>
            <li>Liverpool, L15 4HW, England</li>
            <li>
              <a href="tel:07909324302" className="transition-colors hover:text-primary-600">07909 324302</a>
            </li>
            <li>
              <a href="mailto:fistlimited007@gmail.com" className="break-all transition-colors hover:text-primary-600">
                fistlimited007@gmail.com
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-foreground-200">
        <div className="container-x flex flex-col items-center justify-between gap-3 py-6 text-center sm:flex-row sm:text-left">
          <p className="text-xs text-secondary-500">
            © {new Date().getFullYear()} Fist Limited. All rights reserved.
          </p>
          <p className="text-xs text-secondary-500">86 Eastdale Road, Liverpool, L15 4HW</p>
        </div>
      </div>
    </footer>
  );
}